import React from "react";
import BackArrow from "./BackArrow";
import classes from './BackArrowTitle.module.css';

const BackArrowTitle = ({ text, onClick }) => {
    return (
        <div className={classes.Title}>
            <BackArrow text={text} onClick={onClick} />
        </div>
    )
}

export default BackArrowTitle;